<template>
  <b-row>
    <b-col sm="12">
      <b-card :title = "metadata.label">
        <b-tabs v-model="tabindex" content-class="mt-3">
          <template v-for="(item2, index2) in metadata.choices">
            <b-tab v-bind:key="index2" :title="item2.display_name">
              <template v-for="(item, index) in item2.children">
                <FormComponent :metadata='item' :dbfield='index' :key='"comp_"+index' v-model="groupvalue[index]"
                  v-on:input="$emit('input', groupvalue)" :isEdit="isEdit" :isSearch="isSearch"
                  v-on:updatex="updatex"/>
              </template>
            </b-tab>
          </template>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'

export default {
  name: 'FormComponentGroupSelect',
  extends: FormComponentBase,
  components: {
    FormComponent: () => import('./FormComponent')
  },
  data () {
    return {
      groupvalue: { type: this.metadata.choices[0].value },
      tabindex: 0
    }
  },
  mounted () {
    if (this.value) {
      this.groupvalue = this.value
    }
  },
  watch: {
    tabindex: function (val) {
      this.$set(this.groupvalue, 'type', this.metadata.choices[val].value)
      this.$emit('input', this.groupvalue)
      console.log('change')
    },
    value: function (val) {
      /* for (var i in val) {
        this.$set(this.groupvalue, i, val[i])
      } */
      /* for (var item in this.metadata.children) {
        if (!(item in val)) {
          val.item = null
        }
      } */
      var tabindex = 0
      for (var i in this.metadata.choices) {
        if (!('type' in val) || this.metadata.choices[i].value === val.type) {
          for (var item in this.metadata.choices[i].children) {
            if (!(item in val)) {
              val.item = null
            }
          }
          if (this.metadata.choices[i].value === val.type) {
            this.$set(this, 'tabindex', tabindex)
          }
        }
        tabindex = tabindex + 1
      }
      this.$set(this, 'groupvalue', val)
      this.$emit('valuechange', val)
    }
  }
}
</script>
